import { Shield, Bot, Sparkles } from "lucide-react";

export function TrustSignals() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 py-4">
      <TrustBadge icon={<Shield className="h-3.5 w-3.5" />} label="AI-Powered" />
      <TrustBadge icon={<Bot className="h-3.5 w-3.5" />} label="No Human Operators" />
      <TrustBadge icon={<Sparkles className="h-3.5 w-3.5" />} label="Real-Time Intelligence" />
    </div>
  );
}

function TrustBadge({ icon, label }: { icon: React.ReactNode; label: string }) {
  return (
    <div className="flex items-center gap-1.5 text-gray-500">
      {icon}
      <span className="text-[11px] font-medium">{label}</span>
    </div>
  );
}
